import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'

import { BlueBeanOperatorMappingComponent } from './bluebean-operator-mapping.component'

/**
 * 突合 UI (`app-bluebean-operator-mapping`) をダイアログ表示するための薄いラッパー。
 * 既存のインライン部品は変更せずそのまま埋め込み、ヘッダーと閉じる導線だけを足す。
 * 部品が自前で fetch するため MAT_DIALOG_DATA は受け取らない。
 */
@Component({
  selector: 'app-bluebean-operator-mapping-dialog',
  standalone: true,
  imports: [MatIcon, BlueBeanOperatorMappingComponent],
  templateUrl: './bluebean-operator-mapping-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bluebean-operator-mapping-dialog.component.scss',
})
export class BlueBeanOperatorMappingDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<BlueBeanOperatorMappingDialogComponent>,
  ) {}

  close(): void {
    this.dialogRef.close()
  }
}
